import { render, staticRenderFns } from "./Methods.vue?vue&type=template&id=63ccbdd8"
import script from "./Methods.vue?vue&type=script&lang=js"
export * from "./Methods.vue?vue&type=script&lang=js"
import style0 from "./Methods.vue?vue&type=style&index=0&id=63ccbdd8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports